import { render, staticRenderFns } from "./Pickup.vue?vue&type=template&id=56b792f2&scoped=true&"
import script from "./Pickup.vue?vue&type=script&lang=js&"
export * from "./Pickup.vue?vue&type=script&lang=js&"
import style0 from "./Pickup.vue?vue&type=style&index=0&id=56b792f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b792f2",
  null
  
)

export default component.exports